import { FShallowGraph, FShallowNodeBase, FShallowNodeTypesEnum } from '../types/index.js';

import { SHALLOW_GRAPH_VERSION } from './version.js';

export const shallowNodeRequiredKeys = ['type'] satisfies (keyof FShallowNodeBase)[];

export const shallowNodeDefaultValues = {
  position: [0, 0],
  rotation: 0,
  visible: true,
} as const;

export const shallowInitState: FShallowGraph = {
  type: FShallowNodeTypesEnum.Root,
  name: null,
  space: 0,
  version: SHALLOW_GRAPH_VERSION,
  cursor: null,
  nodes: {},
};
